import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ConsentBanner from './components/ConsentBanner';
import HomePage from './pages/HomePage';
import GpaCalculatorPage from './pages/GpaCalculatorPage';
import CgpaCalculatorPage from './pages/CgpaCalculatorPage';
import GradeConverterPage from './pages/GradeConverterPage';
import FaqIndexPage from './pages/FaqIndexPage';
import FaqArticlePage from './pages/FaqArticlePage';
import LegalPage from './pages/LegalPage';
import NotFoundPage from './pages/NotFoundPage';
import { getConsentStatus, setConsentStatus } from './services/consent';
import { initializeAnalyticsIfConsented } from './services/analytics';
import { initializeTheme } from './services/theme';

const legalContent = {
  about: { title: 'About', path: '/about', body: ['GradeVIT is a student-focused utility platform for VIT Vellore grade calculations and academic FAQs.', 'This website is not affiliated with or officially operated by VIT Vellore.', 'All calculator outputs are estimates based on user inputs.'] },
  privacy: { title: 'Privacy Policy', path: '/privacy-policy', body: ['We do not store personal academic records, login details, or user accounts.', 'Anonymous analytics may be collected only after consent to improve performance and content.', 'Local browser storage is used for consent preference only.'] },
  terms: { title: 'Terms & Conditions', path: '/terms-and-conditions', body: ['By using GradeVIT, you agree that results are informational estimates and not official university records.', 'You are responsible for verifying outcomes against official academic data.', 'We may update content and formulas when VIT policies change.'] },
  contact: { title: 'Contact', path: '/contact', body: ['For feedback, corrections, or partnerships, contact: feedback@technie.in', 'Please include page URL and issue details for quicker response.', 'We welcome suggestions that improve clarity for VITians.'] },
  disclaimer: { title: 'Disclaimer', path: '/disclaimer', body: ['GradeVIT provides educational estimation tools only.', 'No guarantee is made that output matches official transcript or policy interpretation.', 'Always refer to official VIT communications for final academic decisions.'] }
};

export default function App() {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    initializeTheme();
    const status = getConsentStatus();
    setConsent(status);
    if (status === 'accepted') initializeAnalyticsIfConsented();
  }, []);

  function acceptConsent() {
    setConsentStatus('accepted');
    setConsent('accepted');
    initializeAnalyticsIfConsented();
  }

  function rejectConsent() {
    setConsentStatus('rejected');
    setConsent('rejected');
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gpa-calculator" element={<GpaCalculatorPage />} />
        <Route path="/cgpa-calculator" element={<CgpaCalculatorPage />} />
        <Route path="/grade-converter" element={<GradeConverterPage />} />
        <Route path="/faq" element={<FaqIndexPage />} />
        <Route path="/faq/:slug" element={<FaqArticlePage />} />
        <Route path="/about" element={<LegalPage {...legalContent.about} />} />
        <Route path="/privacy-policy" element={<LegalPage {...legalContent.privacy} />} />
        <Route path="/terms-and-conditions" element={<LegalPage {...legalContent.terms} />} />
        <Route path="/contact" element={<LegalPage {...legalContent.contact} />} />
        <Route path="/disclaimer" element={<LegalPage {...legalContent.disclaimer} />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
      {consent === null ? <ConsentBanner onAccept={acceptConsent} onReject={rejectConsent} /> : null}
    </Layout>
  );
}
